import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default () => {
  const { search } = useLocation();

  const decodedSearch = decodeURIComponent(search);

  return useMemo(() => new URLSearchParams(decodedSearch), [decodedSearch]);
};
